import { doc, setDoc, increment, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../firebase";

export const trackActivity = async (eventName) => {
  try {
    const user = auth.currentUser;
    if (!user) return;

    const ref = doc(db, "userActivity", user.uid);
    await setDoc(ref, {
      userId: user.uid,
      email: user.email,
      displayName: user.displayName || "",
      lastActive: serverTimestamp(),
      [`events.${eventName}`]: increment(1),
      totalEvents: increment(1),
    }, { merge: true });

  } catch (err) {
    console.error("trackActivity error:", err.message);
  }
};
